<div class="report-dialog">
  <div class="report-dialog__header">
    <h2 mat-dialog-title>Zahlungsbericht</h2>
    <button type="button" class="icon-btn" (click)="close()" aria-label="Schließen">&times;</button>
  </div>

  <div class="report-dialog__toolbar">
    <div class="mode-toggle">
      <label>
        <input type="radio" name="reportMode" value="zeitraum" [(ngModel)]="mode" />
        Zeitraum
      </label>
      <label>
        <input type="radio" name="reportMode" value="aktenzeichen" [(ngModel)]="mode" />
        Aktenzeichen
      </label>
    </div>

    <div class="criteria" *ngIf="mode === 'zeitraum'">
      <label>
        Von
        <input type="date" [(ngModel)]="dateFrom" />
      </label>
      <label>
        Bis
        <input type="date" [(ngModel)]="dateTo" />
      </label>
    </div>

    <div class="criteria" *ngIf="mode === 'aktenzeichen'">
      <label>
        Aktenzeichen
        <input type="text" [(ngModel)]="aktenzeichen" placeholder="z.B. 1008104242" />
      </label>
    </div>

    <button type="button" class="btn btn-primary" (click)="updatePreview()" [disabled]="loadingPreview">
      Vorschau aktualisieren
    </button>
  </div>

  <div class="report-dialog__body" mat-dialog-content>
    <div class="status" *ngIf="loadingPreview">Vorschau wird geladen ...</div>
    <div class="status error" *ngIf="errorMsg">{{ errorMsg }}</div>

    <iframe
      #previewFrame
      *ngIf="previewUrl"
      class="preview-frame"
      [src]="previewUrl"
      title="Berichtsvorschau"></iframe>

    <div class="status" *ngIf="!previewUrl && !loadingPreview && !errorMsg">
      Wählen Sie Kriterien und klicken Sie auf "Vorschau aktualisieren".
    </div>
  </div>

  <div class="report-dialog__footer" mat-dialog-actions>
    <button type="button" class="btn" (click)="close()">Schließen</button>
    <span class="spacer"></span>
    <button type="button" class="btn" (click)="printReport()" [disabled]="!previewUrl">Drucken</button>
    <button type="button" class="btn btn-primary" (click)="downloadPdf()" [disabled]="downloadingPdf">
      {{ downloadingPdf ? 'Wird erstellt ...' : 'Als PDF speichern' }}
    </button>
  </div>
</div>
